import styled from 'foundations-theming/utils';
import EditorConditionActions from './EditorConditionActions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Container = styled.div.withConfig({
  displayName: "EditorConditionActionsContainer__Container",
  componentId: "sc-9i2d83-0"
})(["position:relative;"]);
const ConditionActionsContainer = styled.div.withConfig({
  displayName: "EditorConditionActionsContainer__ConditionActionsContainer",
  componentId: "sc-9i2d83-1"
})(["position:absolute;top:9px;right:13px;z-index:1;"]);
const EditorConditionActionsContainer = props => {
  const {
    children,
    dataSeleniumInfo,
    onConditionDelete,
    condition,
    filterFamily,
    conditionPath,
    isFilterBranch,
    isRefinement
  } = props;
  if (isRefinement) {
    return /*#__PURE__*/_jsx(Container, {
      children: children
    });
  }
  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsx(ConditionActionsContainer, {
      children: /*#__PURE__*/_jsx(EditorConditionActions, {
        condition: condition,
        conditionPath: conditionPath
        // @ts-expect-error ts-migrate(2322) FIXME: Type '{ condition: any; conditionPath: any; dataSe... Remove this comment to see the full error message
        ,
        dataSeleniumInfo: dataSeleniumInfo,
        filterFamily: filterFamily,
        isFilterBranch: isFilterBranch,
        onConditionDelete: onConditionDelete
      })
    }), children]
  });
};
export default EditorConditionActionsContainer;